import { render, staticRenderFns } from "./FreelanceEdit.vue?vue&type=template&id=731dec4f&"
import script from "./FreelanceEdit.vue?vue&type=script&lang=js&"
export * from "./FreelanceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports